// extracted by mini-css-extract-plugin
module.exports = {"static":"SnSiTR","title":"XfJ7EE"};